import React, {useState, useEffect, useRef} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useCart} from "../context/CartContext";
import {getCategories} from "../api";
import "./Header.css";

const STATIC_NAV = [
  {label: "Home", to: "/"},
  {label: "Bestsellers", to: "/products?bestseller=true"},
  {label: "Contact", to: "/contact"},
];

export default function Header() {
  const {totalItems} = useCart();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [cartBounce, setCartBounce] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    getCategories()
      .then((r) => setCategories(r.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (totalItems > 0) {
      setCartBounce(true);
      const t = setTimeout(() => setCartBounce(false), 400);
      return () => clearTimeout(t);
    }
  }, [totalItems]);

  useEffect(() => {
    function onClick(e) {
      if (headerRef.current && !headerRef.current.contains(e.target))
        setOpenMenu(null);
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  function handleSearch(e) {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/products?search=${encodeURIComponent(search.trim())}`);
      setSearch("");
      setMobileOpen(false);
    }
  }

  const navItems = [
    ...STATIC_NAV,
    {
      label: "Shop",
      children: categories.map((c) => ({
        label: c.name,
        to: `/products?category=${c._id}`,
      })),
    },
    {label: "All ", to: "/products"},
  ];

  return (
    <header className="header" ref={headerRef}>
      <div className="header-inner">
        {/* <Link to="/" className="logo" onClick={() => setMobileOpen(false)}>
          <span className="logo-mark">◆</span>
          <span className="logo-text">Variant Exclusive</span>
        </Link> */}
        <Link to="/" className="logo" onClick={() => setMobileOpen(false)}>
          <img
            src={require("../assets/logo/logo-ve.png")}
            alt="Variant Exclusive"
            className="logo-img"
          />
        </Link>
        <nav className="desktop-nav">
          {navItems.map((item) =>
            item.children ? (
              <div className="nav-item dropdown-trigger" key={item.label}>
                <button
                  className={`nav-link ${openMenu === item.label ? "active" : ""}`}
                  onClick={() =>
                    setOpenMenu(openMenu === item.label ? null : item.label)
                  }
                >
                  {item.label}{" "}
                  <span className="chevron">
                    {openMenu === item.label ? "▲" : "▼"}
                  </span>
                </button>
                {openMenu === item.label && item.children.length > 0 && (
                  <div className="dropdown">
                    {item.children.map((child) => (
                      <Link
                        key={child.label}
                        to={child.to}
                        className="dropdown-item"
                        onClick={() => setOpenMenu(null)}
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link key={item.label} to={item.to} className="nav-link">
                {item.label}
              </Link>
            ),
          )}
        </nav>
        <div className="header-actions">
          <form className="search-form" onSubmit={handleSearch}>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search…"
              className="search-input"
            />
            <button type="submit" className="search-btn">
              🔍
            </button>
          </form>
          <Link to="/cart" className="cart-btn">
            <span className="cart-icon">🛒</span>
            {totalItems > 0 && (
              <span className={`cart-badge ${cartBounce ? "bounce" : ""}`}>
                {totalItems}
              </span>
            )}
          </Link>
          <Link
            to="/track-order"
            className="cart-btn track-btn"
            title="Track your Order"
            aria-label="Track Order"
            onClick={() => setMobileOpen(false)}
          >
            <span className="cart-icon">📦</span>
            <span className="track-btn-label">Track Order here</span>
          </Link>
          <button
            className="hamburger"
            onClick={() => setMobileOpen((o) => !o)}
          >
            {mobileOpen ? "✕" : "☰"}
          </button>
        </div>
      </div>
      {mobileOpen && (
        <nav className="mobile-nav">
          {navItems.map((item) =>
            item.children ? (
              <div key={item.label} className="mobile-group">
                <button
                  className="mobile-group-label"
                  onClick={() =>
                    setOpenMenu(openMenu === item.label ? null : item.label)
                  }
                >
                  {item.label} {openMenu === item.label ? "▲" : "▼"}
                </button>
                {openMenu === item.label &&
                  item.children.map((child) => (
                    <Link
                      key={child.label}
                      to={child.to}
                      className="mobile-link sub"
                      onClick={() => {
                        setMobileOpen(false);
                        setOpenMenu(null);
                      }}
                    >
                      {child.label}
                    </Link>
                  ))}
              </div>
            ) : (
              <Link
                key={item.label}
                to={item.to}
                className="mobile-link"
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </Link>
            ),
          )}
        </nav>
      )}
    </header>
  );
}
